<div class="flex flex-col gap-3">
  <soft-ds-card>
    <soft-ds-card-header>
      <soft-ds-card-title>
        {{ address()?.vorname }} {{ address()?.nachname }}
      </soft-ds-card-title>
    </soft-ds-card-header>
    <soft-ds-card-body>
      <div class="grid grid-cols-2 items-center gap-3">
        <span class="text-light">Lieferdatum</span>
        <span class="text-right">{{ lieferdatum() | date }}</span>
        @if (palettenModus() !== PalettenModus.Keine) {
          <span class="text-light">
            {{ '#DELIVERY_NOTE.DETAILS.PALETTEN_MODUS.' + palettenModus() | translate }}
          </span>
          <span
            class="text-right"
            [class]="
              numOfErledigtPaletten() === paletten().length
                ? 'text-success-600'
                : 'text-warning'
            "
          >
            {{ numOfErledigtPaletten() }}/{{ paletten().length }} Paletten
          </span>
        }
        <span>{{ address()?.strasse }}, {{ address()?.plz }} {{ address()?.ort }}</span>
      </div>
    </soft-ds-card-body>
  </soft-ds-card>

  <div class="flex gap-2 w-full">
    <soft-ds-button variant="outline" class="flex-1" (click)="openNavigation()">
      <soft-icon *softSlot="'leading'" name="fa-regular fa-location-dot" />
      Navigation
    </soft-ds-button>
    <soft-ds-button variant="outline" class="flex-1" (click)="openPhone()">
      <soft-icon *softSlot="'leading'" name="fa-regular fa-phone" />
      Anrufen
    </soft-ds-button>
    <soft-ds-button variant="outline" class="flex-1" (click)="fotoClicked.emit()">
      <soft-icon *softSlot="'leading'" name="fa-regular fa-camera" />
      Foto
    </soft-ds-button>
  </div>
</div>
